import React, { useState } from "react";
import { Card, Grid, Divider, Button } from "@material-ui/core";
import { BarChart } from "@material-ui/icons";

import InstitutionalProjectTable from "../../containers/InstitutionalProject/InstitutionalProjectTable";
import InstitutionalProjectButton from "../../containers/InstitutionalProject/InstitutionalProjectButton";
import InstitutionalProjectStatistics from "../../containers/InstitutionalProject/InstitutionalProjectStatistics";
import { get } from "immutable";
import { getCurrentSchoolYear } from "containers/User/TimeResearch/utils";
import { useContentHeight } from "../../utils/useContentHeight";

// Layout 2026-09-11: dùng CONTENT_HEIGHT (100vh - header - footer) + flex column
// thay cho calc(100vh - 108px) kèm Grid item height:100% — cách cũ làm tổng
// chiều cao vượt Card nên paging tụt xuống dưới, bị footer fixed che.

function InstitutionalProject(props) {
  const [filterObj, setFilterObj] = useState(null);
  const [year, setYear] = useState(getCurrentSchoolYear());
  const [chosenDepartmentId, setChosenDepartmentId] = useState(0);
  // Refactor 2026-05-21: reloadKey để bump Table refetch dueDate khi user click
  // Replay (xem ghi chú trong StudentProject.js).
  const [reloadKey, setReloadKey] = useState(0);
  const bumpReload = () => setReloadKey((k) => k + 1);

  // Chiều cao vùng nội dung, tự trừ header + footer (footer cao 60px khi ≤960px).
  const contentHeight = useContentHeight();
  // Tên đề tài thường là cột dài nhất → thu nhỏ panel thống kê (9/3 → 10/2) và
  // cho phép ẩn hẳn để bảng có tối đa chiều rộng, hạn chế xuống dòng.
  const [showStats, setShowStats] = useState(true);

  return (
    <Card
      style={{
        padding: "8px 16px",
        height: contentHeight,
        maxHeight: contentHeight,
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <Grid container spacing={1} style={{ flexShrink: 0 }}>
        <InstitutionalProjectButton
          year={year}
          type={props.type}
          setYear={setYear}
          setFilterObj={setFilterObj}
          chosenDepartmentId={chosenDepartmentId}
          setChosenDepartmentId={setChosenDepartmentId}
          bumpReload={bumpReload}
        />
        <Grid item xs={12} style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
          <Button
            size="small"
            variant="outlined"
            startIcon={<BarChart />}
            onClick={() => setShowStats(!showStats)}
          >
            {showStats ? "Ẩn thống kê" : "Hiện thống kê"}
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
      </Grid>

      {/* Vùng bảng — chiếm chiều cao còn lại. `minHeight: 0` bắt buộc để flex
          item co được dưới kích thước nội dung. */}
      <Grid container spacing={1} style={{ flex: 1, minHeight: 0 }}>
        <Grid item xs={12} md={showStats ? 10 : 12} style={{ height: "100%" }}>
          <InstitutionalProjectTable
            year={year}
            type={props.type}
            filterObj={filterObj}
            reloadKey={reloadKey}
          />
        </Grid>
        {showStats && (
          <Grid item xs={12} md={2} style={{ height: "100%", overflow: "auto" }}>
            <InstitutionalProjectStatistics />
          </Grid>
        )}
      </Grid>
    </Card>
  );
}

export default InstitutionalProject;

